const getDefaultState = () => {
  return {
    regionCode: window.defaultRegionCode,
    language: 'en_US',
    timeZone: 'Asia/Shanghai',
    externalParam: {}, // 外部传入的参数,各个页面共用vuex数据
    registerParam: {}, // 注册页面传入的参数，不走路由，用于跨页面传递数据
    resetPwdParam: {}, // 重置密码页面传入的参数
    selectMobileRegionCode: '' // 选择的手机区号
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },

  SET_SELECT_MOBILE_REGION_CODE: (state, selectMobileRegionCode) => {
    state.selectMobileRegionCode = selectMobileRegionCode
  },

  SET_REGISTER_PARAM: (state, registerParam) => {
    state.registerParam = registerParam
  },

  SET_RESET_PWD_PARAM: (state, resetPwdParam) => {
    state.resetPwdParam = resetPwdParam
  },

  SET_LANGUAGE: (state, language) => {
    state.language = language
  },

  SET_REGION_CODE: (state, regionCode) => {
    state.regionCode = regionCode
  },

  SET_TIME_ZONE: (state, timeZone) => {
    state.timeZone = timeZone
  },

  SET_EXTERNAL_PARAM: (state, externalParam) => {
    state.externalParam = externalParam
  }
}

const actions = {

  setRegisterParam({ commit }, registerParam) {
    commit('SET_REGISTER_PARAM', registerParam)
  },

  setResetPwdParam({ commit }, resetPwdParam) {
    commit('SET_RESET_PWD_PARAM', resetPwdParam)
  },

  setSelectMobileRegionCode({ commit }, selectMobileRegionCode) {
    commit('SET_SELECT_MOBILE_REGION_CODE', selectMobileRegionCode)
  },

  setExternalParam({ commit }, param){
    commit('SET_EXTERNAL_PARAM', param)
    commit('SET_LANGUAGE', param.lang || 'en_US')
    commit('SET_REGION_CODE', param.region || window.defaultRegionCode)
    commit('SET_TIME_ZONE', param.timezone || 'Asia/Shanghai')
  },

  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
